export const kk = {
    locale: 'kk',
    likert: {
        'lik.mind.1': 'Біреумен жақындаспас бұрын, маған қандай отбасы керегін түсінуге тырысамын.',
        'lik.mind.2': 'Адам маған қатты ұнаса, оның кемшіліктері мазаламай қалады.',
        'lik.mind.3': 'Өмірге көзқарасымыз сәйкес келмесе, ұнаған адамнан бас тарта аламын.',
        'lik.mind.4': 'Жақын қарым-қатынас туралы шешімді сол сәттегі сезіміме қарап қабылдаймын.',
        'lik.mind.5': 'Онсыз отбасы құрмайтын екі-үш қасиетті нақты атай аламын.',
        'lik.ready.1': 'Отбасы мен қарым-қатынас туралы кітап оқыдым немесе арнайы оқудан өттім.',
        'lik.ready.2': 'Тойдан кейінгі алғашқы жылы тұрмысымыз қалай болатынын елестете аламын.',
        'lik.ready.3': 'Отбасылық өмір туралы «үйленейік, әрі қарай көре жатармыз» деп ойлаймын.',
        'lik.ready.4': 'Отбасылы адамдардан тойдан кейін не таңғалдырғанын сұрағанмын.',
        'lik.ready.5': 'Бірге тұра бастағанда өзімнің қандай әдеттерімді өзгертуім керегін білемін.',
        'lik.mission.1': 'Өмірімді неге арнағым келетінін сөзбен түсіндіре аламын.',
        'lik.mission.2': 'Ақы төленбесе де айналысатын іспен айналысамын.',
        'lik.mission.3': 'Он жылдан кейін өзімді қай жерде көретінімді айту қиын.',
        'lik.mission.4': 'Ерте тұрып, шаршауға дайын болатындай мақсатым бар.',
        'lik.mission.5': 'Әртүрлі нәрсені сынап көремін, бірақ әлі өз ісімді таппадым.',
        'lik.role.1': 'Менің өз жолым бар, оны отбасы үшін тастамаймын.',
        'lik.role.2': 'Үлкен ісі бар адамның қолдаушысы болуды өзіме лайық көремін.',
        'lik.role.3': 'Жарымның ісі үшін басқа қалаға көшуге дайынмын.',
        'lik.role.4': 'Жарым өз жағына тартпай, менің жолымды қолдағаны маңызды.',
        'lik.role.5': 'Өзімнің емес, жарымның ісі жүріп кеткені маған маңыздырақ.',
        'lik.home.1': 'Отбасын ақшамен қамтамасыз ету — ер адамның ісі.',
        'lik.home.2': 'Үй шаруасы мен табысты екеуара тең бөлген дұрыс.',
        'lik.home.3': 'Маған күйеуі мен әйелінің міндеттері бірдей емес, бөлек отбасы жақынырақ.',
        'lik.home.4': 'Екеуі де жұмыс істесе, кешкі ас та, ыдыс та кезекпен бөлінеді.',
        'lik.home.5': 'Әйел жұмыс істей алады, бірақ үйді асырау — оның міндеті емес.',
        'lik.kin.1': 'Ата-анамен — өзімнің не жарымның — бірге тұру мен үшін қалыпты жағдай.',
        'lik.kin.2': 'Алғашқы жылдары отбасы аяғынан тұру үшін бөлек тұрғаны дұрыс.',
        'lik.kin.3': 'Ата-ана біздің отбасы шешімдеріне қатыса алады.',
        'lik.kin.4': 'Ата-анама қиын болғанда, оларды өзіме алуға дайынмын.',
        'lik.kin.5': 'Екеуміздің арамызда болған нәрсе туыстармен талқыланбауы керек.',
        'lik.resp.1': 'Қарым-қатынас нашарлағанда, алдымен екінші жақ бастасын деп күтемін.',
        'lik.resp.2': 'Арамыз суысса, ең алдымен өзім нені өзгерте алатынымды қараймын.',
        'lik.resp.3': 'Отбасы бақыты жартылай менен, жартылай жарымнан.',
        'lik.resp.4': 'Кінәлі болмасам да, бітімге бірінші өзім барамын.',
        'lik.resp.5': 'Адам маған не жетіспейтінін өзі түсінгенше ұзақ күте аламын.',
        'lik.accept.1': 'Тойдан кейін жарымның кейбір әдеттерін өзгерте аламын деп есептеймін.',
        'lik.accept.2': 'Адамды өзіме ұнамайтын жақтарымен бірге қабылдаймын.',
        'lik.accept.3': 'Адам мен үшін өзгеремін деп уәде етсе, сеніп күтемін.',
        'lik.accept.4': 'Адам басқа болып кетеді деген үмітпен отбасы құрмаймын.',
        'lik.accept.5': 'Жарымды тәрбиелеп ала аламын деп ойлаймын.',
    },
    likertScale: ['Ешқашан', 'Сирек', 'Кейде', 'Әдетте', 'Әрдайым'],
    likertHints: ['бұл мен туралы емес', '', 'жағдайға қарай', '', 'бұл нақты мен туралы'],
    axes: {
        mind: {
            name: 'Жарымды қалай таңдаймын',
            left: 'Сезімге еремін',
            right: 'Ойланып таразылаймын',
            hi: 'Сіз таразылайсыз. Өзіңіз үшін қандай қасиеттер шешуші екенін алдын ала білесіз және басты нәрсе сәйкес келмесе, ұнаған адамнан бас тарта аласыз.',
            mid: 'Сізде сезім де, есеп те жұмыс істейді. Назар аударатын тұс — шешуші сәтте дауысты сезімге бермеу.',
            lo: 'Сіз сезімге ересіз: ұнату сізге шарттар тізімінен маңыздырақ. Ғашықтықтың шыңында қабылданған шешім кейін көбіне қайта қаралады.',
        },
        ready: {
            name: 'Отбасы өміріне дайындық',
            left: 'Жүре көре жатармын',
            right: 'Алдын ала дайындаламын',
            hi: 'Сіз саналы түрде дайындаласыз: оқисыз, сұрайсыз, тұрмысты алдын ала елестетесіз. Бұл — ең бағаланбайтын бөлік, ал сіз оны істеп жүрсіз.',
            mid: 'Бірдеңені ойластырғансыз, бірақ көбін «кейінге» қалдырғансыз. Негізгісін жабуға әдетте алты ай жетеді.',
            lo: 'Сіз жүре көре жатармын деп есептейсіз. Бұл алғашқы елеулі қақтығысқа дейін ғана жұмыс істейді — одан әрі тірі қарым-қатынаста үйренуге тура келеді.',
        },
        mission: {
            name: 'Өз ісім және өмірдегі бағытым',
            left: 'Өз ісімді әлі іздеп жүрмін',
            right: 'Қайда бара жатқанымды білемін',
            hi: 'Сізде сөзбен түсіндіре алатын іс пен бағыт бар. Бұл — өзіңізге де, жарыңызға да тірек.',
            mid: 'Бағыт табылған, бірақ шекарасы бұлыңғыр. Тексеріп көріңіз: ақы төленбесе де немен айналысар едіңіз?',
            lo: 'Сіз әлі өз ісіңізді іздеп жүрсіз. Бұл кемшілік емес — бірақ жарыңыз қасында дайын нүктедегі емес, жолдағы адам тұрғанын білгені жөн.',
        },
        role: {
            name: 'Жұптағы рөл: өз жолым ба, тірек пе',
            left: 'Мен — жарыма тірекпін',
            right: 'Менің өз жолым бар',
            hi: 'Өз жолы. Сіз бөтен істе еріп кетуге дайын емессіз, сізге мұны құрметтейтін адам керек.',
            mid: 'Сіз қатар жүретін екі жолды көресіз: әрқайсысында өз ісі, бағыт ортақ.',
            lo: 'Тірек. Сізге жарыңыздың ісі жүріп кеткені маңыздырақ; бөтен істі өз ісіңіздей істеуге дайынсыз.',
        },
        home: {
            name: 'Үй тұрмысы: шаруа мен ақша',
            left: 'Бәрін тең бөлеміз',
            right: 'Ерлі-зайыптының рөлі бөлек',
            hi: 'Дәстүрлі тұрмыс: күйеуі мен әйелінің міндеттері бөлек, үйді асырау — ер адамның ісі.',
            mid: 'Аралас тұрмыс — бір бөлігі теңдей, бір бөлігі рөлге қарай. Өзара өкпе көбіне дәл осы жерден туады: шекараны меңзеп қана қоймай, дауыстап айту керек.',
            lo: 'Серіктестік тұрмыс: ақша да, ас үй де, шаруа да екеуара шамамен тең бөлінеді.',
        },
        kin: {
            name: 'Туыстар мен отбасы шекарасы',
            left: 'Туыстардан бөлек тұрамыз',
            right: 'Туыстар — отбасымыздың ішінде',
            hi: 'Туыстар — отбасыңыздың бөлігі: қатар тұру, шешімге қатысу, ата-ананы өзіңізге алу сіз үшін қалыпты.',
            mid: 'Туыстарды жақын ұстайсыз, бірақ бәрінде емес. Тек екеуара шешілетін нәрсені дауыстап атап алған пайдалы.',
            lo: 'Отбасыңыз — жеке контур. Ата-анаңызды жақсы көресіз, бірақ шешімді екеуара қабылдап, ішке кіргізбейсіз.',
        },
        resp: {
            name: 'Қарым-қатынас үшін жауапкершілік',
            left: 'Бірінші қадамды екіншісінен күтемін',
            right: 'Бірінші қадамды өзім жасаймын',
            hi: 'Сіз жауапкершілікті толық өзіңізге аласыз және бітімге бірінші барасыз. Отбасы беріктігінің кілті — осы.',
            mid: 'Сіз жауапкершілікті жартылай бөлесіз — «жартысы менен, жартысы одан». Бұл формула қауіпті: екі жарты бір-бірін күтіп отырады да, ешкім қозғалмайды.',
            lo: 'Сіз екінші жақ бірінші бастасын деп күтуге бейімсіз. Бұл — күту залы сияқты: екеуі отыр да, ешкім жарияламайтын рейсті күтеді.',
        },
        accept: {
            name: 'Адамды бар қалпында қабылдау',
            left: 'Өзгертемін деп есептеймін',
            right: 'Бар қалпында қабылдаймын',
            hi: 'Сіз адамды ұнамайтын жақтарымен бірге қабылдайсыз және қайта тәрбиелеу жоспарын құрмайсыз.',
            mid: 'Көп нәрсені қабылдайсыз, бірақ біраз нәрсені «түзеп алуды» ойлайсыз. Оны нақты атап, өзгермесе сонымен өмір сүре аласыз ба екенін тексерген жөн.',
            lo: 'Сіз адамды тойдан кейін өзгертемін деп есептейсіз. Бұл — ең жиі кездесетін қате: екеуі де шаршайды, ал тойға дейінгі уәделерді әркім өзінше түсінген.',
        },
    },
    conditions: {
        faith: { title: 'Дін', hint: 'Сенім, ғибадат, намаз, ораза — бұл қаншалықты сәйкес келуі керек.' },
        language: { title: 'Отбасындағы тіл', hint: 'Үйде қай тілде сөйлейсіздер және балаларды қай тілде оқытасыздар.' },
        origin: { title: 'Ұлты мен тегі', hint: 'Жарыңыздың шыққан тегі, өңірі, шежіресі.' },
        age: { title: 'Жасы', hint: 'Үлкен, кіші, құрдас — бұл қаншалықты принципті.' },
        education: { title: 'Білімі', hint: 'Жоғары білім және адамның шынымен оқығаны.' },
        past: { title: 'Бұрынғы неке және балалар', hint: 'Адам бұрын некеде болды ма, баласы бар ма.' },
        looks: { title: 'Сырт келбеті мен талғамы', hint: 'Адам қалай көрінеді, өзіне қарай ма, қалай киінеді.' },
        wealth: { title: 'Тұрмысы мен баспанасы', hint: 'Табысы, өз пәтері, тойға дейінгі қаржылық тұрақтылығы.' },
        separateHome: { title: 'Ата-анадан бөлек тұру', hint: 'Бірінші күннен бөлек үй — әлде қалай болса, солай.' },
        children: { title: 'Балалар: қашан және неше', hint: 'Мерзімі, саны, тіпті бала сүюге дайындығы.' },
        wifeCareer: { title: 'Әйелдің жұмысы мен мансабы', hint: 'Әйелі жұмыс істей ме және бұл кімнің ақшасы.' },
        geography: { title: 'Қайда тұру', hint: 'Қала, ауыл, басқа елге көшу.' },
    },
    levels: ['Міндетті', 'Маңызды', 'Қалаулы'],
    levelHints: [
        'онсыз отбасы құрмаймын',
        'маңызды, бірақ көз жұма аламын',
        'болса жақсы; шешуші емес',
    ],
    forks: {
        live: {
            title: 'Ата-ана тойдан кейін бірге тұруға шақырады.',
            options: ['Келісемін — солай дұрыс', 'Бөлек тұрамыз, бұл шешілген', 'Екеуара шешіп, ата-анаға бірге айтамыз'],
        },
        money: {
            title: 'Әйелдің жалақысы.',
            options: ['Ортақ отбасы бюджетіне түседі', 'Өзінде қалады', 'Ай сайын екеуара шешеміз'],
        },
        whoDecides: {
            title: 'Келіннің төркініне қашан баратынын кім шешеді.',
            options: ['Ене екеуі келіседі', 'Тек күйеуі мен әйелі', 'Жағдайға қарай, қатаң ереже жоқ'],
        },
        wedding: {
            title: 'Той.',
            options: ['Үлкен той, барлық салтымен', 'Қарапайым — ақша отбасы бастауына', 'Орташа, ата-ана қалай шешсе'],
        },
        conflict: {
            title: 'Алғашқы елеулі жанжал.',
            options: ['Суымай тұрып бірден айтамын', 'Аз-кем үзіліс алып, сосын сөйлесемін', 'Өзінен-өзі басылғанша күтемін'],
        },
        cooled: {
            title: 'Бір жылдан кейін сезім суыды.',
            options: ['Маманға барамыз', 'Екеуара шешеміз', 'Бұл қалыпты, бәрінде солай'],
        },
    },
    self: {
        'self.age': { title: 'Жасыңыз нешеде?', hint: '', placeholder: 'мысалы, 24' },
        'self.city': { title: 'Қайда тұрасыз?', hint: 'Қала не ауыл — өзіңіз қалай атасаңыз.', placeholder: 'мысалы, Алматы' },
        'self.faith': { title: 'Өміріңіздегі дін', hint: 'Шындыққа ең жақын жолды таңдаңыз.' },
        'self.lang': { title: 'Сіздегі қазақ тілі', hint: '' },
        'self.edu': { title: 'Біліміңіз', hint: '' },
        'self.past': { title: 'Некеде болдыңыз ба?', hint: '' },
        'self.field': { title: 'Сіздің ісіңіз', hint: 'Жұмыс істейтін немесе оқитын саласыңыз.' },
    },
    want: {
        'want.faith': {
            title: 'Жарыңыздың діншілдігі',
            hint: 'Қай деңгейден төмен түспейсіз.',
            options: [
                'Төмен емес: дінге теріс қарайды',
                'Төмен емес: бәрібір',
                'Төмен емес: құрметтейді, бірақ ғибадат етпейді',
                'Төмен емес: кейбір парыздарды орындайды',
                'Төмен емес: дін — өмір салты',
                'Төмен емес: дін — өмір мәні',
                'Маңызды емес',
            ],
        },
        'want.lang': {
            title: 'Жарыңыздағы қазақ тілі',
            hint: '',
            options: [
                'Төмен емес: ұнатпайды, үйренгісі келмейді',
                'Төмен емес: мүлдем түсінбейді',
                'Төмен емес: түсінеді, бірақ сөйлемейді',
                'Төмен емес: сөйлейді, бірақ басқа тілде ойлайды',
                'Төмен емес: қазақша сөйлеп, қазақша ойлайды',
                'Төмен емес: тек қазақша ойлайды',
                'Маңызды емес',
            ],
        },
        'want.age': {
            title: 'Жарыңыздың жасы',
            hint: '',
            options: ['Менен кіші', 'Құрдас — үш жасқа дейінгі айырма', 'Менен үлкен', 'Маңызды емес'],
        },
        'want.edu': {
            title: 'Жарыңыздың білімі',
            hint: '',
            options: ['Жоғары білім, әрі шынымен оқыған', 'Дипломы болса жеткілікті', 'Маңызды емес'],
        },
        'want.past': {
            title: 'Жарыңыздың бұрынғы некесі',
            hint: '',
            options: [
                'Тек некеде болмаған адам',
                'Неке болған — қабылдаймын, бірақ баласыз',
                'Баласымен де қабылдаймын',
                'Маңызды емес',
            ],
        },
        'want.geo': {
            title: 'Қайда тұруға дайынсыз',
            hint: '',
            options: ['Тек өз қаламда', 'Жарымның артынан көшуге дайынмын', 'Тек қалада, ауылда емес', 'Маңызды емес'],
        },
    },
    scales: {
        faith: [
            'Дінге теріс қараймын',
            'Бар-жоғы маған бәрібір',
            'Құрметтеймін, бірақ ғибадат етпеймін',
            'Кейбір парыздарды орындаймын',
            'Дін — менің өмір салтым',
            'Дін — өмірімнің мәні',
        ],
        lang: [
            'Қазақшаны ұнатпаймын, үйренгім келмейді',
            'Қазақша мүлдем түсінбеймін',
            'Түсінемін, бірақ сөйлей алмаймын',
            'Сөйлеймін, бірақ басқа тілде ойлаймын',
            'Қазақша сөйлеп, қазақша ойлаймын',
            'Бүкіл ойлауым қазақ тілінде қалыптасқан',
        ],
        edu: [
            'Шынымен оқыдым, өз ісімді білемін',
            'Дипломым бар, бірақ мамандығымды нашар білемін',
            'Жоғары білімім жоқ',
        ],
        past: ['Некеде болмадым', 'Болдым, балам жоқ', 'Болдым, балам бар', 'Жесір'],
        field: [
            'Ғылым және білім',
            'Бизнес және өз ісі',
            'Мемлекеттік қызмет',
            'Медицина',
            'IT және техника',
            'Шығармашылық және өнер',
            'Спорт',
            'Дін саласы',
            'Жұмысшы мамандығы',
            'Үй, отбасы, балалар',
            'Әлі өз ісімді іздеп жүрмін',
        ],
        anyValue: 'Маңызды емес',
    },
    zones: {
        'zone.cond.clash': '«{cond}»: біреуі үшін бұл міндетті, екіншісі үшін тек қалаулы. Біреуіңіз үшін онсыз отбасы болмайды, екіншісі үшін бұл міндетті емес бөлшек.',
        'zone.cond.differ': '«{cond}»: салмағы әртүрлі. Біреуі маңызды деп санайды, екіншісі — екінші кезектегі.',
        'zone.cond.bothStem': '«{cond}» — екеуі үшін де міндетті. Ең бастысында сәйкес келдіңіздер.',
        'zone.axis.critical': '«{axis}»: айырма {delta} тармақ. Тұрмыс, рөлдер және туыстармен шекара алғашқы жылы ең көп жанжал тудырады.',
        'zone.axis.differ': '«{axis}»: әртүрлі қарайсыздар. Қауіпті емес, бірақ сөйлесіп алған жөн.',
        'zone.axis.same': '«{axis}» — сәйкес келесіздер.',
        'zone.flag.wantsToChange': 'Адамды өзгертемін деген есеп. Ең жиі кездесетін қате: тойға дейінгі уәделерді әркім өзінше түсінеді, ал шаршайтыны — екеуі.',
        'zone.flag.bothWaiting': 'Екеуі де екіншісінің қадамын күтеді. «Күту залы»: екеуі отыр да, ешкім жарияламайтын рейсті күтеді.',
        'zone.flag.unprepared': 'Екеуіңіз де дайындалмағансыз. Бұл үкім емес — тек алдағы алты айды дұрыс өткізу керек.',
        'zone.fork.heavy': '{fork}: жауаптарыңыз әртүрлі, әрі бұл — ақша не туыстар туралы, жанжалдың ең жиі себебі.',
        'zone.fork.light': '{fork}: жауаптар алшақтады.',
        'zone.nothingMajor': 'Ірі алшақтық табылмады. Бірақ сөйлесетін ештеңе жоқ дегені емес: шарттар картасын тармақ-тармағымен дауыстап өтіңіздер.',
    },
    gates: {
        'gate.age': 'Жарының жасы талапқа сай емес ({age}).',
        'gate.level': '«{cond}» — міндетті шарт: {need} деңгейінен төмен емес керек, жарында {has}.',
        'gate.eduReal': 'Шынымен оқыған адам керек.',
        'gate.eduAny': 'Жоғары білімі бар адам керек.',
        'gate.pastMarried': 'Тек некеде болмағанды қабылдайды.',
        'gate.pastChild': 'Бұрынғы некеден туған баланы қабылдауға дайын емес.',
        'gate.geography': 'Қалалар бөлек ({cityA} және {cityB}), әрі екеуі де көшуге дайын емес.',
    },
    flags: {
        'flag.wantsToChange': 'Жарын өзгертемін деп есептейді',
        'flag.waiting': 'Екіншісінің қадамын күтеді',
        'flag.unprepared': 'Дайындалмаған',
        'flag.bothWaiting': 'Екеуі де екіншісін күтеді',
    },
    reasons: {
        'why.home.same': 'Үй тұрмысы сәйкес: рөлдер мен ақшаға бірдей қарайды.',
        'why.kin.same': 'Туыстар мен отбасы шекарасына бірдей қарайды.',
        'why.role.strong': 'Рөл моделі тұрақты: {model}.',
        'why.cond.same': '12 шарттың {count} шарты маңыздылық деңгейі бойынша сәйкес келді.',
        'why.fork.money': 'Ақша мен туыстарға қатысты үш айырықтың үшеуіне де бірдей жауап береді.',
        'why.field.same': 'Қызмет саласы ортақ.',
        'why.home.differ': 'Үй тұрмысын әртүрлі көреді: біреуі бөлек рөлдерді күтеді, екіншісі — «теңдей».',
        'why.kin.differ': 'Туыстардың отбасы өміріне қаншалықты араласатынында келіспейді.',
        'why.role.weak': 'Рөлдер сәтсіз қалыптасады: {model}.',
        'why.cond.clash': 'Біреуінде «міндетті», екіншісінде «қалаулы» болған шарттар саны: {count}. Бірінші кезекте осы тақырыптар туралы сөйлесу керек.',
        'why.fork.differ': '{fork}: жауаптар алшақ.',
    },
    roleModels: {
        leaderSupport: {
            label: 'жетекші мен тірек',
            note: 'Біреуі өз жолымен жүреді, екіншісі — оның тірегі. Модельдердің ең тұрақтысы.',
        },
        sideBySide: {
            label: 'қатар жүреді',
            note: 'Бір бағыттағы екі жол: әрқайсысында өз ісі, бағыт ортақ.',
        },
        apart: {
            label: 'екі жол екі жаққа',
            note: 'Екеуі де өз жолынан бас тартпайды. Ең тұрақсыз орналасу: ортақ мүдде жоқ.',
        },
        bothSupport: {
            label: 'екеуі де тірек',
            note: 'Екеуі де қолдауға дайын — бірақ ешкім жетектемейді. Отбасында кімнің ісі басты екенін шешуге тура келеді.',
        },
        mixed: {
            label: 'аралас',
            note: 'Рөлдер бөлінеді, бірақ шекараны алдын ала айтып алған жөн.',
        },
    },
    talk: {
        'talk.home.1': 'Алғашқы жылы үйді кім асырайды және табыс азайса не болады?',
        'talk.home.2': 'Екеуі жұмыстан келген жұмыс күні кешінде кім ас әзірлеп, кім ыдыс жуады?',
        'talk.home.3': 'Әркім «әйелдің міндеті» мен «еркектің міндеті» дегенге не жатқызады — үш-үштен дауыстап атаңыздар.',
        'talk.kin.1': 'Ата-анамен бірге тұрамыз ба, бөлек пе — және қай күннен бастап?',
        'talk.kin.2': 'Қандай шешімдер туыстарсыз, тек екеуара қабылданады?',
        'talk.kin.3': 'Ата-ана келіспегенде олармен кім сөйлеседі — ұлы ма, келіні ме?',
        'talk.role.1': 'Алдағы бес жылда кімнің ісі басты және неге?',
        'talk.role.2': 'Екіншісінің ісі үшін көшуге дайынсың ба?',
        'talk.role.3': 'Екіншісінің соңынан ерсе, әрқайсың не жоғалтасың?',
        'talk.mind.1': 'Той туралы алғаш ойлағанда не сезіндің — және сабырлы ақылмен не ойлайсың?',
        'talk.mind.2': 'Әркім қандай шарттарды «міндетті» деп атады — тізімдеріңізді салыстырыңыздар.',
        'talk.mind.3': 'Ең бастысы үшін әркім неден бас тартуға дайын?',
        'talk.ready.1': 'Дайындалу үшін алдағы алты айда екеуің нақты не істейсіңдер?',
        'talk.ready.2': 'Он жыл бірге тұрғандардың қайсысынан кеңес сұрайсыңдар?',
        'talk.ready.3': 'Әркім өзінің қандай әдеттерін өзгертуге дайын?',
        'talk.mission.1': 'Ақы төленбесе де әрқайсың немен айналысар едің?',
        'talk.mission.2': 'Он жылдан кейін екеуің өздеріңді қай жерде көресіңдер — бір жерде ме?',
        'talk.mission.3': 'Таңдау керек болса, әркімге не маңызды: ісі ме, отбасы ма?',
        'talk.resp.1': 'Екеуіңнің араңда бітімге бірінші қадамды әдетте кім жасайды?',
        'talk.resp.2': 'Екіншісін күтпей-ақ әркім өзі не істей алады?',
        'talk.resp.3': 'Көмекке жүгінетін уақыт келгенін қалай түсінесіңдер?',
        'talk.accept.1': 'Екіншісінде уақыт өте нені өзгертуге үміттенесің? Дауыстап айт.',
        'talk.accept.2': 'Ол ешқашан өзгермесе, сонымен өмір сүре аласың ба?',
        'talk.accept.3': 'Әркім өзінде нені бар қалпында қабылдауды сұрайды?',
        'talk.cond.1': 'Бұл тармаққа нақты не мағына салып тұрсың — нақтылап айт.',
        'talk.cond.2': 'Сенше істесек не болады? Менше істесек ше?',
    },
    parts: {
        1: 'Мен қандаймын',
        2: 'Менің шарттарым',
        3: 'Айырықтар',
        4: 'Өзім туралы',
        5: 'Жарымнан не күтемін',
    },
    push: {
        'pair.accepted': {
            title: 'Шақыру қабылданды',
            body: '{name} сілтемеңізді қабылдады. Тестті екеуің де өткенде талдау дайын болады.',
        },
        'pair.accepted.ready': {
            title: 'Шақыру қабылданды',
            body: '{name} сілтемеңізді қабылдады, жұбыңыздың талдауы да дайын.',
        },
        'pair.ready': {
            title: 'Жұп талдауы дайын',
            body: 'Тестті екеуің де өттіңдер — {name} екеуіңнің талдауын ашуға болады.',
        },
        'match.sent': {
            title: 'Таңдауда жұп бар',
            body: 'Сізге жұп таңдалды. Көру үшін қолданбаны ашыңыз.',
        },
    },
};
//# sourceMappingURL=kk.js.map